import Bottle, { IContainer } from 'bottlejs';
import { Store } from 'redux';

import { configureAppStore } from './store';
import { createFirewall } from './firewall';
import { createNotificationsApi, createSendwiseApi, createTouchpointsApi } from './api';
import TouchpointsApi from './api/touchpoints';
import { initI18n } from './i18n';

import getPermissions from './actions/permissions';
const bottle = new Bottle();

// DO NOT add anything new here, consider using React Context for DI

bottle.factory('store', () => configureAppStore());
// @ts-ignore
bottle.factory('firewall', (container) => createFirewall(container.store));
// @ts-ignore
bottle.factory('api', (container) => createSendwiseApi(container.store));
// @ts-ignore
bottle.factory('touchpointsApi', (container) => createTouchpointsApi(container.store));
// @ts-ignore
bottle.factory('notificationsApi', (container) => createNotificationsApi(container.store));
// @ts-ignore
bottle.factory('i18n', (container) => initI18n(container.store));

bottle.value('actions.getPermissions', getPermissions);
bottle.value('env', {
  refreshTokenInterval: process.env.SENDWISE_REFRESH_TOKEN_INTERVAL || 30,
});

interface AppContainer extends IContainer {
  store: Store;
  touchpointsApi: TouchpointsApi;
}

export default bottle.container as AppContainer;
